import {
    CANDIDATE_PRO2_UPDATE_REQUEST,
    CANDIDATE_PRO2_UPDATE_SUCCESS,
    CANDIDATE_PRO2_UPDATE_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_API_PATH

export const CandidateProAction2 = (data,navigate) => {
    return function (dispatch) {
        dispatch({
            type: CANDIDATE_PRO2_UPDATE_REQUEST,
            payload: true,
        });
        // const token = JSON.parse(localStorage.getItem("jwt"))
        //   ? JSON.parse(localStorage.getItem("jwt"))
        //   : "";
        let OPTION = {
            url: `${baseUrl}/ebench/update_Candidate_v2`,
            method: "PUT",
            data: data,
            headers: {
                "Content-Type": "multipart/form-data",
                // token: token,
            },
        };

        axios(OPTION)
            .then((res) => {
                dispatch(updateDashboardContentPre(res.data,navigate));
                //   window.location.href = "/candidate_dashboard";
            })
            .catch((error) => {
                dispatch({
                    type: CANDIDATE_PRO2_UPDATE_FAIL,
                    payload: false,
                    error: error,
                    msg: "Failed to load the information",
                });

            });
    };
};

export const updateDashboardContentPre = (data,navigate) => {
    toast.success("Updated Successfully!");
    // window.location.href = "/candidate_dashboard"
    // setTimeout(() => {
    //     navigate("/candidate_dashboard");
    //   }, 1500); 
    
    return {
        type: CANDIDATE_PRO2_UPDATE_SUCCESS,
        result: data,
        payload: false,
        msg: "SUCCESS",
    };
};